export const Forbidden403PageTestIds = {
  DASHBOARD_LINK: 'error-403.dashboard-link',
};
